/**
 * @returns Date as String in bribane formated as `DD Weekday Month`
 */
const dateNowBris = (): string => {
    const dateTime = new Date();

    const formattedDate = dateTime.toLocaleDateString("en-AU", {
        timeZone: "Australia/Brisbane",
        weekday: "short",
        day: "numeric",
        month: "short"
    });

    return formattedDate;
}

/**
 * @returns Time in Brisbane formatted in "short" time style
 */
const timeNowBris = (): string => {
    const dateTime = new Date();

    const formattedTime = dateTime.toLocaleTimeString("en-AU", {
        timeZone: "Australia/Brisbane",
        timeStyle: "short"
    });

    return formattedTime;
}

/**
 * @param date Date string
 * @returns formated date DD-MM-YYYY
 */
const getFormattedDate = (date: string): string => {

    const formattedDate = new Date(date);

    return `${String(formattedDate.getUTCDate()).padStart(2, '0')}/${String(formattedDate.getUTCMonth() + 1).padStart(2, '0')}/${formattedDate.getUTCFullYear()}`;
}

// Strict YYYY-MM-DD -> local Date, or undefined if the string isn't a real date.
const parseISODate = (value: string): Date | undefined => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
    if (!match) return undefined;

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const date = new Date(year, month - 1, day);
    date.setHours(0, 0, 0, 0);

    // Reject rolled-over dates like 2026-02-31.
    if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
    ) {
        return undefined;
    }
    return date;
};

const isWithin = (date: Date, min: Date, max: Date) =>
    date.getTime() >= min.getTime() && date.getTime() <= max.getTime();

export { dateNowBris, timeNowBris, getFormattedDate, parseISODate, isWithin };